import React from "react";

const videos = {
  Production: [
    { title: "Bondhu Bine", url: "https://www.youtube.com/embed/CDlKT8GR3cQ" },
    { title: "Duranto Srabon", url: "https://www.youtube.com/embed/daOiF04QodI" },
    { title: "Dekh Bhai/Duranto", url: "https://www.youtube.com/embed/vuWIECjuyHY" },
  ],
  Musical: [
    { title: "Grow On Me", url: "https://www.youtube.com/embed/N0Evik4JgLE" },
  ],
};

const iframeStyle = {
  width: "100%",
  maxWidth: "350px",
  height: "197px",
  border: 0,
  display: "block",
  margin: "0 auto"
};

const LinksSection = () => (
  <section className="py-5" style={{ color: "#0d6efd" }}>
    <div className="container text-center">
      <h1 className="mb-4" style={{ color: "#0d6efd" }}>Check out my creative contributions</h1>
    </div>
    <div className="container">
      <div className="row justify-content-center">
        {/* Production Videos */}
        <div className="col-12 col-md-6 mb-5 mb-md-0 text-center">
          <h3 className="mb-3" style={{ color: "#0d6efd" }}>Production</h3>
          <div className="d-flex flex-column align-items-center gap-4">
            {videos.Production.map((video, idx) => (
              <div key={idx}>
                <iframe
                  src={video.url}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={iframeStyle}
                />
              </div>
            ))}
          </div>
        </div>
        {/* Musical Videos */}
        <div className="col-12 col-md-6 text-center">
          <h3 className="mb-3" style={{ color: "#0d6efd" }}>Musical</h3>
          <div className="d-flex flex-column align-items-center gap-4">
            {videos.Musical.map((video, idx) => (
              <div key={idx}>
                <iframe
                  src={video.url}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={iframeStyle}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LinksSection;